import { User } from '@hakimo-ui/hakimo/types';
import { createContext, useContext, useMemo } from 'react';

export const INTERNAL_EMAIL_DOMAIN = '@hakimo.ai';

/**
 * Rest of the application will not see this value
 * and will see a response from server instead
 */
const defaultValue: User = {
  id: '',
  email: '',
  name: '',
  roles: [],
  permissions: [],
  userIntercomHash: '',
  mspTenants: [],
  mspLocations: [],
  visionTenants: [],
  enabled: true,
  tenant: {
    id: '',
    name: '',
  },
};

export const UserProfileContext = createContext(defaultValue);

export function useUser() {
  const user = useContext(UserProfileContext);
  return user;
}

export function useIsInternalUser() {
  const user = useUser();
  return useMemo(() => {
    return !!user?.email?.endsWith(INTERNAL_EMAIL_DOMAIN);
  }, [user?.email]);
}
